import { createSelector } from 'reselect'
import { selectSiteAbbr } from 'services/site/selectors'
import { selectQuery } from 'services/routing/selectors'

export const selectAds = (state) => state.ads

export const selectAdUnitPaths = createSelector(
  selectAds,
  (ads) => ads && ads.adUnitPaths,
)

export const selectAdUnitPath = createSelector(
  selectAdUnitPaths,
  selectSiteAbbr,
  selectQuery,
  (adUnitPaths, abbr, query) => {
    const base = `17729925/UACF_W/${abbr}`
    if (query && typeof query.ad_test !== 'undefined') { return `${base}/MMF_Test/${query.ad_test}` }
    if (adUnitPaths.length === 0) { return '' }
    const subPath = ['', ...adUnitPaths].join(`/${abbr}_`)
    return `${base}${subPath}`
  }
)
